import gql from "graphql-tag";

const userFields = `
id username email
fullname employeeId
position { id name }
department { id name }
`;

export const queryGetUsers = gql`
  query getUsers($query: String) {
    users(query: $query){
        ${userFields}
    }
  }
`;

export const queryGetDetailUserGroupSysByName = gql`
  query getDetailUserGroupSysByName($name: String!) {
    getDetailUserGroupSysByName(name: $name){
      id users{ ${userFields} }
    }
  }
`;

export const mutationAddMoreUsersToUserGroupSys = gql`
  mutation addMoreUsersToUserGroupSys(
    $id: ID!
    $userIds: [ID!]!
  ){
    addMoreUsersToUserGroupSys(id: $id data: {userIds: $userIds}){
      id users{ ${userFields} }
    }
  }
`;

export const mutationRemoveUserFromUserGroupSys = gql`
  mutation removeUserFromUserGroupSys(
    $id: ID!
    $removeUserId: ID!
  ){
    removeUserFromUserGroupSys(id: $id removeUserId: $removeUserId){
      id users{ ${userFields} }
    }
  }
`;
